<app-top-nav-registration [llttfPage]="llttfpage"></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
    <div class="content">
        <div class="designatedFacilityForm">
        <h3>{{ 'sgpAccountCreatedTitle' | translate:translations }}</h3>
        <br>
        <span>
            {{ accountCreatedBody }}
        </span>
        <br>
        <div class="form-buttons">
            <a href="/bb-login" class="submit-form-button">{{ 'sgpAccountCreatedLogin' | translate:translations }}</a>

         </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
